import React from 'react';
import PropTypes from 'prop-types';
import { getProp } from '../../utilities';

class Comments extends React.PureComponent {
  componentDidMount() {
    if (!this.refresh()) {
      setTimeout(() => {
        // keby nahodou to nebolo nacitane, skusime o sekundu neskor
        this.refresh();
      }, 1000);
    }
  }

  componentDidUpdate() {
    this.refresh();
  }

  refresh() {
    if (typeof window.FB !== 'undefined') {
      getProp(window.FB, 'XFBML.parse', () => {})();
      return true;
    }
    return false;
  }

  render() {
    return (
      <div
        data-width="100%"
        className="fb-comments"
        data-href={this.props.canonicalUrl}
        data-numposts="5"
      />
    );
  }
}

Comments.propTypes = {
  canonicalUrl: PropTypes.string.isRequired,
};

export default Comments;



// WEBPACK FOOTER //
// ./src/ui/src/component/facebook/comments.js